import { LayerRenderer } from '../LayerRenderer';
import { CloseButton, animationClass, cardStyle, useDismissible, type SurfaceProps } from './common';

/**
 * Plovoucí karta v rohu (`floating` pop-up i `floating_widget` weblayer).
 * NEmodální, nepřekrývá košíkové CTA na mobilu (řeší CSS). Rohovou pozici
 * bere z nastavení.
 */
export function FloatingSurface({ layer, onClose, onInteract, onSubmitted }: SurfaceProps) {
  const settings = layer.doc.settings;
  useDismissible(onClose);

  const corner =
    settings.position === 'bottom_left'
      ? 'is-bottom-left'
      : settings.position === 'top_right'
        ? 'is-top-right'
        : settings.position === 'top_left'
          ? 'is-top-left'
          : 'is-bottom-right';

  return (
    <div
      className={`layer-floating ${corner} ${animationClass(settings)}`}
      style={cardStyle(settings, true)}
      role="dialog"
      aria-label={settings.dismissLabel ?? 'Sdělení'}
    >
      {(settings.closeButton ?? true) && <CloseButton onClose={onClose} />}
      <LayerRenderer
        layer={layer}
        onClose={onClose}
        onInteract={onInteract}
        onSubmitted={onSubmitted}
      />
    </div>
  );
}
